import { useQuery } from 'react-query';
import { getAllSellableRoundTemplates } from 'src/apis/roundTemplate';
import { GetRoundTemplatesAPIResponse } from 'types';

export const useGetAllSellableRoundTemplates = (
	isJobseekerLoggedIn: boolean,
	fetch?: boolean,
	onComplete?: (data: GetRoundTemplatesAPIResponse) => void,
) => {
	return useQuery({
		queryKey: ['getAllSellableRoundTemplates'],
		queryFn: async () => (await getAllSellableRoundTemplates()) as GetRoundTemplatesAPIResponse,
		staleTime: 0,
		enabled: fetch && isJobseekerLoggedIn,
		refetchOnMount: true,
		onSuccess(data) {
			onComplete && onComplete(data);
		},
	});
};
